<template>
  <ul class="mission-honeycomb" :class="{ 'is-completed': mission.hasCompleted }">
    <li
      v-for="(condition, index) in mission.achievementCondition"
      :key="index"
      class="mission-honeycomb__item"
    >
      <mission-hexagon-parts
        :condition="condition"
        :prevCondition="getPrevCondition(index)"
        :mission="mission"
        :checkInMissionsBeingHeld="checkInMissionsBeingHeld"
      />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionHexagonParts from '@/components/MissionPage/MissionListPane/parts/MissionHexagonParts.vue'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'
import MissionProgressDocument from '@/store/stores/collectionModule/documents/mission/MissionProgressDocument'

/**
 * ミッション画面 ミッション達成状況 ハニカム12個パーツ
 */
export default defineComponent({
  name: 'MissionHoneycombTwelveParts',
  components: {
    MissionHexagonParts,
  },
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
    /**
     * 開催中のラウンドチェックインまたはイベントチェックインミッション一覧
     */
    checkInMissionsBeingHeld: {
      type: Array as PropType<MissionProgressDocument[]>,
      required: true,
    },
  },
  setup(props) {
    /**
     * 一つ前の達成条件を取得する
     */
    const getPrevCondition = (index: number) =>
      index > 0 ? props.mission.achievementCondition?.[index - 1] : 'noPreviousCondition'

    return {
      getPrevCondition,
    }
  },
})
</script>

<style scoped lang="scss">
.mission-honeycomb {
  display: flex;
  gap: min(#{convertPXtoVW(4)}, 4px);
  flex-wrap: wrap;
  width: min(#{convertPXtoVW(325)}, 325px);

  &__item {
    flex-shrink: 0;

    &:nth-child(5) {
      margin-left: min(#{convertPXtoVW(33)}, 33px);
    }

    &:nth-child(9) {
      margin-left: min(#{convertPXtoVW(65)}, 65px);
    }

    &:nth-child(n + 5) {
      margin-top: max(-#{convertPXtoVW(20)}, -20px);
    }

    ::v-deep {
      .mission-card-hexagon {
        width: min(#{convertPXtoVW(62)}, 62px);
        height: min(#{convertPXtoVW(72)}, 72px);
      }

      .mission-card-hexagon__outer {
        width: min(#{convertPXtoVW(62)}, 62px);
        height: min(#{convertPXtoVW(72)}, 72px);
      }

      .mission-card-hexagon__inner {
        width: min(#{convertPXtoVW(54)}, 54px);
        height: min(#{convertPXtoVW(64)}, 64px);
      }
    }
  }

  &.is-completed {
    width: min(#{convertPXtoVW(256)}, 256px);

    .mission-honeycomb__item {
      &:nth-child(5) {
        margin-left: min(#{convertPXtoVW(26)}, 26px);
      }

      &:nth-child(9) {
        margin-left: min(#{convertPXtoVW(51)}, 51px);
      }

      &:nth-child(n + 5) {
        margin-top: max(-#{convertPXtoVW(15)}, -15px);
      }

      ::v-deep {
        .mission-card-hexagon {
          width: min(#{convertPXtoVW(48)}, 48px);
          height: min(#{convertPXtoVW(55)}, 55px);
        }

        .mission-card-hexagon__outer {
          width: min(#{convertPXtoVW(48)}, 48px);
          height: min(#{convertPXtoVW(55)}, 55px);
        }

        .mission-card-hexagon__inner {
          width: min(#{convertPXtoVW(41)}, 41px);
          height: min(#{convertPXtoVW(49)}, 49px);
        }
      }
    }
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    width: min(#{convertPXtoVW(447)}, 447px);

    &__item {
      &:nth-child(5) {
        margin-left: min(#{convertPXtoVW(44)}, 44px);
      }

      &:nth-child(9) {
        margin-left: min(#{convertPXtoVW(88)}, 88px);
      }

      &:nth-child(n + 5) {
        margin-top: max(-#{convertPXtoVW(27)}, -27px);
      }

      ::v-deep {
        .mission-card-hexagon {
          width: min(#{convertPXtoVW(85)}, 85px);
          height: min(#{convertPXtoVW(99)}, 99px);
        }

        .mission-card-hexagon__outer {
          width: min(#{convertPXtoVW(85)}, 85px);
          height: min(#{convertPXtoVW(99)}, 99px);
        }

        .mission-card-hexagon__inner {
          width: min(#{convertPXtoVW(74)}, 74px);
          height: min(#{convertPXtoVW(88)}, 88px);
        }
      }
    }

    &.is-completed {
      width: min(#{convertPXtoVW(447)}, 447px);

      .mission-honeycomb__item {
        &:nth-child(5) {
          margin-left: min(#{convertPXtoVW(44)}, 44px);
        }

        &:nth-child(9) {
          margin-left: min(#{convertPXtoVW(88)}, 88px);
        }

        &:nth-child(n + 5) {
          margin-top: max(-#{convertPXtoVW(27)}, -27px);
        }

        ::v-deep {
          .mission-card-hexagon {
            width: min(#{convertPXtoVW(85)}, 85px);
            height: min(#{convertPXtoVW(99)}, 99px);
          }

          .mission-card-hexagon__outer {
            width: min(#{convertPXtoVW(85)}, 85px);
            height: min(#{convertPXtoVW(99)}, 99px);
          }

          .mission-card-hexagon__inner {
            width: min(#{convertPXtoVW(74)}, 74px);
            height: min(#{convertPXtoVW(88)}, 88px);
          }
        }
      }
    }
  }
}
</style>
